import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class DHTSensorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'dhtSensor',
            name: 'DHT Sensor',
            color1: '#9C27B0',
            color2: '#8E24AA',
            color3: '#7B1FA2',

            blocks: [
                {
                    opcode: 'dht_read',
                    blockType: 'reporter',
                    text: 'read [TYPE] from DHT11 on pin [PIN]',
                    arguments: {
                        TYPE: {
                            type: 'string',
                            defaultValue: 'Temperature',
                            menu: 'dhtTypeMenu'
                        },
                        PIN: {
                            type: 'number',
                            defaultValue: '4',
                            menu: 'digitalPinMenu'
                        }
                    }
                }
            ],

            menus: {
                dhtTypeMenu: {
                    acceptReporters: false,
                    items: [
                        {text: 'Temperature °C', value: 'Temperature'},
                        {text: 'Humidity %', value: 'Humidity'}
                    ]
                }
            },

            codeTemplates: [
                {
                    opcode: 'dht_read',
                    type: 'reporter',
                    arduino: {
                        code: 'dht_{{PIN}}.read{{TYPE}}()',
                        setup: ['dht_{{PIN}}.begin();'],
                        includes: [
                            '#include <DHT.h>',
                            '#define DHTTYPE DHT11',
                            'DHT dht_{{PIN}}({{PIN}}, DHTTYPE);'
                        ]
                    },
                    python: {
                        code: 'dht_{{PIN}}.temperature() if "{{TYPE}}" == "Temperature" else dht_{{PIN}}.humidity()',
                        setup: [
                            'dht_{{PIN}} = dht.DHT11(Pin({{PIN}}))',
                            'dht_{{PIN}}.measure()'
                        ],
                        imports: ['import dht', 'from machine import Pin']
                    }
                }
            ]
        };
    }

    dht_read (args) {
        if (args.TYPE === 'Temperature') {
            return 24 + Math.floor(Math.random() * 5); // Simulate 24-28 C
        }
        return 40 + Math.floor(Math.random() * 20); // Simulate 40-60% Humidity
    }
}

export default DHTSensorExtension;
